import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=ef67317a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=ef67317a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef67317a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef67317a')) {
      api.createRecord('ef67317a', component.options)
    } else {
      api.reload('ef67317a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=ef67317a&scoped=true&", function () {
      api.rerender('ef67317a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I2Dc2I9z5pZB/JS/comp/DocBox.vue"
export default component.exports